import { useContext } from "react";
import { useMutation, useQueryClient } from "react-query";
import { BRANCH_ENDPOINT, buildBranchCacheKey } from ".";
import { IUpdateBranchInput } from "../../../../api-schema/branch";
import { AuthContext } from "../../contexts/AuthProvider";
import { putRequest } from "../apiClient";

const updateBranch = async (data: IUpdateBranchInput, token: string) => {
  await putRequest(BRANCH_ENDPOINT, data, token);
  return true;
};

export const useUpdateBranch = (bId: string) => {
  const queryClient = useQueryClient();
  const { token } = useContext(AuthContext);
  const { mutate, isLoading, isSuccess, isError } = useMutation(
    (data: {
      questionnaireDiscountRate?: number | undefined;
      lotteryDiscountRate?: number | undefined;
      lotteryProbability?: number | undefined;
    }) => updateBranch({ ...data, bId }, token),
    {
      mutationKey: buildBranchCacheKey({ bId }),
      // 成功時にはキャッシュをクリアする(キャッシュがなくなるとReactQueryが自動で再取得してくれる)
      onSuccess: () =>
        queryClient.invalidateQueries(buildBranchCacheKey({ bId })),
    }
  );
  return { mutate, isLoading, isSuccess, isError };
};
